// export const BASE_URL = "http://localhost:8000/v1";
export const BASE_URL = "https://backend.secuber.io/v1";
// export const BASE_URL="https://secuber.myappsdevelopment.co.in/v1"; 
export const RED = "red";
export const GREY = "grey";
